import { useTranslation } from "react-i18next";
import TrackContainer from "./TrackContainer";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectEventsData, setEventData } from "../events/eventsSlice";
import { sendAnalyticsEvents } from "../../analytics/common";
import { EVENTS } from "../../analytics/events";
import { setRole } from "./infoSlice";

const TargetTrack = ({ history }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const eventsData = useSelector(selectEventsData);
  const targetOptions = useMemo(() => {
    return [
      {
        id: 0,
        imgPath: ('../assets/track_target/partner.png'),
        name: t("partner"),
        value: 'Partner',
      },
      {
        id: 1,
        imgPath: ('../assets/track_target/kid.png'),
        name: t("kid"),
        value: 'Kid',
      },
      {
        id: 2,
        imgPath: ('../assets/track_target/friend.png'),
        name: t("friend"),
        value: 'Friend',
      },
      {
        id: 3,
        imgPath: ('../assets/track_target/sibling.png'),
        name: t("sibling"),
        value: 'Sibling'
      },
      {
        id: 4,
        imgPath: ('../assets/track_target/grandparent.png'),
        name: t("grandparent"),
        value: 'Grandparent'
      },
      {
        id: 5,
        imgPath: ('../assets/track_target/other.png'),
        name: t("other"),
        value: 'Other'
      },
    ];
  }, [t]);

  const onSingleClick = (role) => {
    const choosenOption = targetOptions.find((option) => option.value === role);
    dispatch(setEventData({ id: 'Role', data: role }))
    sendAnalyticsEvents(EVENTS.onboardingRoleSubmitted, {
      ...eventsData,
      Role: role,
    })
    dispatch(setRole(choosenOption?.name))
    history.push('/choose-location');
  }

  return (
    <TrackContainer
      pageEvent={"onboardingRoleShown"}
      title={t("question1_title")}
      options={targetOptions}
      onSingleClick={onSingleClick}
      nextPage={'choose-location'}
    />
  );
};

export default TargetTrack;
